module.exports = __webpack_public_path__ + "static/media/car.4855a806.svg";